import IRole from "../models/IRole";
import { fetchSecureData } from "../utils";

export const saveRole = async (
  accessToken: string,
  name: string,
  displayName: string,
  currencyCodeId: number,
  fyStartMonthId: number,
  isEnabled: boolean
) => {
  try {
    const data = await fetchSecureData(
      "POST",
      `/api/Role/Add?name=${name}&displayName=${displayName}&currencyCodeId=${currencyCodeId}&fyStartMonthId=${fyStartMonthId}&isEnabled=${isEnabled}`,
      accessToken
    );
    const role = ((await data.json()) as any).value as IRole;
    return role;
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(
      `Fetch error for /api/Role/Add?name=${name}&displayName=${displayName}&currencyCodeId=${currencyCodeId}&fyStartMonthId=${fyStartMonthId}&isEnabled=${isEnabled}`,
      err
    );
  }
  return {} as IRole;
};

export default saveRole;
